import { registerPageInit } from '../barba/page-init-registry';
import '../../css/_root.scss';
import '../../css/pages/education/index.scss';
import { syncListLoadMoreVisibility } from '../utils/ajax-load-more';
import { initEducationProgramsLoadMore } from '../utils/education-programs-load-more';
import { initNewsFiltersAutoSubmit } from '../utils/news-filters';
import { applyServerSearchResults, initSearchInput } from '../utils/search-input';
import { initPermissionRequest } from '../widgets/permission-request';
import {
  initEducationPageTabsNav,
  scrollActiveEducationTabIntoView,
} from '../utils/education-page-tabs';

const EDUCATION_PROGRAMS_SEARCH_ID = 'educationProgramsSearch';
const EDUCATION_PERMISSION_OPEN_EVENT = 'stc:education-permission-open';
const EDUCATION_PERMISSION_INIT_FLAG = 'educationPermissionOpenBound';

const EDUCATION_PROGRAMS_LIST_CONFIG = {
  gridSelector: '[data-education-programs-grid]',
  wrapSelector: '[data-education-programs-load-more-wrap]',
  cardSelector: '[data-education-program-card]',
} as const;

const EDUCATION_PROGRAMS_AJAX_CONFIG = {
  ...EDUCATION_PROGRAMS_LIST_CONFIG,
  loadingSelector: '[data-education-programs-content]',
  skeletonVariant: 'programs' as const,
  skeletonCount: 3,
  modalsContainerSelector: '[data-education-program-modals]',
  search: {
    inputId: EDUCATION_PROGRAMS_SEARCH_ID,
    highlight: {
      cardSelector: '[data-education-program-card]',
      fields: [
        { selector: '.education-program-card__title' },
        { selector: '.education-program-card__description' },
      ],
    },
  },
};

function bindEducationPermissionOpenTriggers(root?: ParentNode): void {
  const scope =
    root?.querySelector<HTMLElement>('[data-barba-namespace="education-programs"]') ??
    root ??
    document;

  if (!(scope instanceof HTMLElement) || scope.dataset[EDUCATION_PERMISSION_INIT_FLAG] === 'true') {
    return;
  }

  scope.dataset[EDUCATION_PERMISSION_INIT_FLAG] = 'true';
  scope.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const trigger = target.closest('[data-education-permission-open]');
    if (!trigger || !scope.contains(trigger)) return;

    window.dispatchEvent(new CustomEvent(EDUCATION_PERMISSION_OPEN_EVENT));
  });
}

function getEducationProgramsScope(root?: ParentNode): ParentNode {
  return (
    root?.querySelector<HTMLElement>('[data-barba-namespace="education-programs"]') ??
    root ??
    document
  );
}

registerPageInit('education-programs', (root) => {
  initEducationPageTabsNav();
  const scope = getEducationProgramsScope(root);

  initSearchInput(scope, {
    inputId: EDUCATION_PROGRAMS_SEARCH_ID,
    mode: 'server',
    urlParam: 'q',
  });

  initNewsFiltersAutoSubmit(scope, {
    searchInputId: EDUCATION_PROGRAMS_SEARCH_ID,
    ajax: EDUCATION_PROGRAMS_AJAX_CONFIG,
  });

  initEducationProgramsLoadMore(scope);

  const urlQuery = new URLSearchParams(window.location.search).get('q');
  if (urlQuery) {
    applyServerSearchResults(scope, urlQuery, EDUCATION_PROGRAMS_AJAX_CONFIG.search);
  }
  syncListLoadMoreVisibility(scope, EDUCATION_PROGRAMS_LIST_CONFIG);
  initPermissionRequest(root, { launcher: 'float' });
  bindEducationPermissionOpenTriggers(scope);
  scrollActiveEducationTabIntoView(scope);
});
